export default __webpack_public_path__ + "images/crosslink-teaser--cart.svg?aef7ab7ceac8dd827b8c3dac4804adae";